export const TRANSLATIONS = {
  de: {
    register: 'Registrieren',
    signIn: 'Anmelden',
    logout: 'Abmelden',
    profile: 'Profil',
    myLoads: 'Meine Ladungen',
    newLoad: '+ Ladung erstellen',
    available: 'Verfuegbar',
    onTrip: 'Unterwegs',
    imAvailable: 'Ich bin frei',
    deliverLoad: 'Ladung liefern',
    tagline: 'Backhaul-Plattform - Europa',
    liveNetwork: 'Netzwerk',
    trucksActive: 'LKW aktiv',
    members: 'Mitglieder',
    avgLoad: 'Durchschn. Ladung',
    countries: 'Laender',
    verified: 'Verifiziert',
    insured: 'Versichert',
    insurable: 'Versicherbar',
    myLoad: 'Meine Ladung',
    departure: 'Abfahrt',
    estArrival: 'Voraussichtl. Ankunft',
    reserved: 'Reserviert',
    close: 'Schliessen',
    cancel: 'Abbrechen',
    confirm: 'Bestaetigen',
    save: 'Speichern',
    imFree: 'Verfuegbar',
    myLoadsTitle: 'Meine Ladungen',
    profileTitle: 'Profil',
    newLoadBtn: '+ Ladung erstellen',
    toCity: 'nach',
    weInsure: 'Wir versichern dies',
    shipper: 'Absender',
    distance: 'Entfernung',
    weight: 'Gewicht',
    payment: 'Zahlung',
    netDays: '30 Tage netto',
    driverAcceptedTitle: 'Fahrer hat diese Ladung angenommen - Daten abgleichen:',
    driverNameLbl: 'Fahrername',
    plateLbl: 'Kennzeichen',
    vehicleTypeLbl: 'Fahrzeugtyp',
    contactLbl: 'Kontakt',
    matchWarning: 'Bitte gleichen Sie beim Uebergeben unbedingt Kennzeichen und Identitaet des Fahrers ab. Bei Uebergabe an ein anderes Fahrzeug liegt die Verantwortung bei Ihnen.',
    driverRequestedTitle: 'Ein Fahrer hat diese Ladung angefragt:',
    nameLbl: 'Name',
    driverConfirmed: 'Fahrer bestaetigt',
    yourLoadWaiting: 'Diese Ladung wurde von Ihnen erstellt und wartet auf einen Fahrer.',
    confirmDriver: 'Fahrer bestaetigen',
    rejectRequest: 'Anfrage ablehnen',
    deleteLoadBtn: 'Diese Ladung loeschen',
    shipperNoAccept: 'Zur Ansicht der Ladungsdetails. Als Absender koennen Sie keine Ladung annehmen.',
    overCapacityWarning: 'Gewicht dieser Ladung ist hoeher als Ihre Fahrzeugkapazitaet. Sie koennen diese Ladung nicht annehmen.',
    assignedToYou: 'Diese Ladung wurde Ihnen zugewiesen und steht Ihnen zur Verfuegung.',
    goToMyLoads: 'Zum Liefern gehen Sie zu Meine Ladungen.',
    assignedOther: 'Diese Ladung wurde einem anderen Fahrer zugewiesen.',
    pendingYours: 'Sie haben diese Ladung angefragt. Warten Sie auf die Bestaetigung des Absenders.',
    pendingOther: 'Diese Ladung wurde von einem anderen Fahrer reserviert und wartet auf Bestaetigung.',
    requestThisLoad: 'Diese Ladung anfragen',
    changeStatus: 'Status aendern',
    myLoadsModalTitle: 'Meine Ladungen',
    shipperLoadsSubtitle: 'Verlauf Ihrer Ladungen (letzte 2 Jahre)',
    noLoadsShipper: 'Sie haben noch keine Ladung erstellt.',
    statusWaitingDriver: 'Wartet auf Fahrer',
    statusPendingDriver: 'Fahreranfrage',
    statusInTransit: 'Unterwegs',
    statusDelivered: 'Geliefert',
    weightLbl: 'Gewicht',
    priceLbl: 'Preis',
    driverLbl: 'Fahrer',
    approveBtn: 'Bestaetigen',
    rejectBtn: 'Ablehnen',
    myActiveLoadsSubtitle: 'Ihre aktiven Ladungen in Lieferreihenfolge',
    noActiveLoads: 'Sie haben derzeit keine aktive Ladung.',
    generalCargo: 'Allgemeine Ladung',
    statusConfirmed: 'Bestaetigt',
    statusWaitingApproval: 'Wartet auf Bestaetigung',
    deliverThisLoad: 'Diese Ladung liefern',
    cancelThisRequest: 'Diese Anfrage stornieren',
    deliveryHistory: 'Verlauf gelieferter Ladungen',
    delivered: 'Geliefert',
    profileModalTitle: 'Benutzerprofil',
    profileSubtitle: 'Ihre Kontoinformationen',
    roleLbl: 'Rolle',
    roleShipper: 'Absender (Shipper)',
    roleCarrier: 'Transportunternehmen (Carrier)',
    roleDriver: 'Selbststaendiger Fahrer',
    nameLblProfile: 'Name',
    emailPhoneLbl: 'E-Mail / Telefon',
    capacityLbl: 'Kapazitaet',
    companyInfoNote: 'Um Firmendaten zu aendern (Geschaeftsfuehrer, gesetzlicher Vertreter, Registernummer oder Kontaktdaten), wenden Sie sich bitte an den Support. Diese Aenderungen erfordern eine erneute Dokumentenpruefung.',
    changePasswordTitle: 'Passwort aendern',
    newPasswordPh: 'Neues Passwort',
    repeatPasswordPh: 'Neues Passwort wiederholen',
    passwordsMismatch: 'Passwoerter stimmen nicht ueberein',
    savePassword: 'Neues Passwort speichern',
    continuePayment: 'Weiter - Zahlung',
    continueDocs: 'Weiter - Dokumente hochladen',
    underReview: 'Wird geprueft',
    membershipFeeTitle: 'Mitgliedsbeitrag',
    membershipFeeSub: 'Monatlicher Zugang zum EU.LOAD Backhaul-Netzwerk in 18 Laendern.',
    totalLbl: 'Gesamt',
    perMonth: 'EUR/Monat',
    roleIndDriver: 'Selbststaendiger Fahrer',
    roleCarrierCo: 'Transportunternehmen',
    roleShipperCo: 'Absenderunternehmen',
    featuresText: 'Voller EU-weiter Netzwerkzugang\nVerifiziertes Carrier-Abzeichen im Profil\nLadungsversicherung inbegriffen',
    cardNumberPh: 'Kartennummer',
    mmYYPh: 'MM / JJ',
    cvvPh: 'CVV',
    payBtn: 'Zahlen',
    backToLoads: 'Zurueck zu Ladungen',
    uploadDocsTitle: 'Dokumente hochladen',
    uploadDocsSub: 'Tippen Sie auf jedes Dokument, um es als hochgeladen zu markieren. Absender sehen nur Ihr verifiziertes Abzeichen.',
    paymentConfirmed: 'Zahlung bestaetigt',
    uploadVerificationDocs: 'Laden Sie Ihre Verifizierungsdokumente hoch',
    uploadMore: 'Weitere hochladen',
    submitBackToLoads: 'Absenden und zurueck zu Ladungen',
    verificationInProgressTitle: 'Verifizierung laeuft',
    verificationSub1: 'Ihre Dokumente werden geprueft. Dies dauert bis zu',
    verificationSub2: '24 Stunden',
    verificationSub3: 'Sie werden per',
    verificationSub4: 'benachrichtigt, sobald Sie freigeschaltet sind.',
    smsWord: 'SMS',
    emailWord: 'E-Mail',
    reviewStep1: 'Das Compliance-Team prueft Ihre Dokumente',
    reviewStep2: 'Sie werden benachrichtigt, sobald Sie freigeschaltet sind',
    reviewStep3: 'Sie koennen sofort mit der Annahme von Ladungen beginnen',
    demoSimulate: 'Demo: Freischaltung simulieren',
    gotIt: 'Verstanden',
    tripStatusTitle: 'Fahrtstatus',
    tripStatusSub: 'Aktualisieren Sie Ihre Verfuegbarkeit fuer Absender.',
    availableForLoads: 'Verfuegbar fuer Ladungen',
    currentlyOnTrip: 'Derzeit unterwegs',
    busyWarningTitle: 'Ladung wird transportiert',
    busyWarningSub: 'Sie haben derzeit eine Ladung und koennen keine weitere annehmen.\nAendern Sie nach der Lieferung Ihren Status auf "Frei".',
    deliveredNowFree: 'Geliefert - jetzt frei',
    locationRequiredTitle: 'Standort erforderlich',
    locationRequiredSub: 'EU.LOAD benoetigt Ihren GPS-Standort, um Ladungen in der Naehe anzuzeigen.\nBitte aktivieren Sie den Standortzugriff und versuchen Sie es erneut.',
    noLocationSub: 'Ohne Standort ist die Nutzung der App nicht moeglich',
    enableGpsBtn: 'GPS aktivieren',
    retryHint: 'Nach der Aktivierung tippen Sie oben erneut auf die Schaltflaeche',
    skipForNow: 'Vorerst ueberspringen',
    lastUpdateNow: 'Letzte Aktualisierung: jetzt',
    tripProgress: 'Reisefortschritt',
    driverInfo: 'Fahrerinformationen',
    vehicleTypeLbl2: 'Fahrzeugtyp',
    liveTrackingNote: 'Diese Ladung wird live verfolgt.\nBei Problemen kontaktieren Sie den Fahrer oder den EU.LOAD Support.',
    newLoadTitle: 'Neue Ladung erstellen',
    newLoadStep1Sub: 'Schritt 1: Route und Abholzeit',
    fromCityLbl: 'Von',
    selectFromCity: 'Abholstadt auswaehlen',
    toCityLbl: 'Nach',
    selectToCity: 'Zielstadt auswaehlen',
    receiverNameLbl: 'Name des Empfaengers am Zielort',
    receiverNamePh: 'Name des Lagerleiters oder Verantwortlichen',
    pickupAddressLbl: 'Genaue Abholadresse',
    pickupAddressPh: 'Strasse, Hausnummer, PLZ, Ort',
    deliveryAddressLbl: 'Genaue Lieferadresse',
    deliveryAddressPh: 'Strasse, Hausnummer, PLZ, Ort',
    pickupAddressNote: 'Diese Adresse wird dem Fahrer nach Annahme der Ladung angezeigt.',
    addressCheckingLbl: 'Adresse wird geprueft...',
    addressValidLbl: 'Adresse gefunden',
    addressInvalidLbl: 'Adresse nicht gefunden. Bitte pruefen.',
    pickupDateLbl: 'Abholdatum',
    pickupTimeLbl: 'Abholzeit',
    dateNotPast: 'Das Abholdatum darf nicht in der Vergangenheit liegen.',
    dateMax7Days: 'Das Abholdatum darf hoechstens 7 Tage in der Zukunft liegen.',
    continueBtn: 'Weiter',
    cancelBtn: 'Abbrechen',
    cargoDetailsTitle: 'Warendetails',
    newLoadStep2Sub: 'Schritt 2: Art und Verpackung der Ware',
    cargoTypeLbl: 'Warenart',
    selectCargoType: 'Warenart auswaehlen',
    adrWarning: 'Diese Warenart erfordert eine ADR-Genehmigung oder eine besondere Erlaubnis.',
    packagingTypeLbl: 'Verpackungsart',
    onPallet: 'Auf Palette',
    looseCargo: 'Ohne Palette',
    palletCountLbl: 'Anzahl Paletten',
    example10: 'z.B. 10',
    palletWeightLbl: 'Gewicht pro Palette (kg)',
    example500: 'z.B. 500',
    lengthCm: 'Laenge (cm)',
    widthCm: 'Breite (cm)',
    heightCm: 'Hoehe (cm)',
    totalWeightLbl: 'Gesamtgewicht (kg)',
    totalWeightPh: 'Gesamtgewicht der Ladung in kg',
    palletWeightRangeWarning: 'Das Gewicht pro Palette muss zwischen 100 und 1500 kg liegen.',
    palletCountRangeWarning: 'Die Anzahl der Paletten muss zwischen 1 und 66 liegen.',
    backBtn: 'Zurueck',
    shippingInfoTitle: 'Transportinformationen',
    newLoadStep3Sub: 'Schritt 3: Fahrzeugtyp, Preis und Versicherung',
    vehicleTypeNeeded: 'Benoetigter Fahrzeugtyp',
    suggestedPrice: 'Vorgeschlagener Preis (EUR)',
    example2500: 'z.B. 2500',
    cargoValueLbl: 'Warenwert (EUR)',
    cargoValuePh: 'Tatsaechlicher Warenwert - fuer Versicherung',
    notShownToDriver: 'Dieser Betrag wird dem Fahrer nicht angezeigt',
    cargoInsuranceLbl: 'Ladungsversicherung',
    hasFullInsurance: 'Ladung ist voll versichert',
    wantEuloadInsurance: 'EU.LOAD-Versicherung gewuenscht',
    noInsurance: 'Ohne Versicherung',
    euloadPremium: 'EU.LOAD-Praemie:',
    percentValueNote: '(0.5% des Warenwerts)',
    noInsuranceWarning: 'Ohne Versicherung liegt die volle Verantwortung bei Schaeden oder Verlust der Ladung bei Ihnen, es erfolgt keine Deckung.',
    extraNotesLbl: 'Zusaetzliche Hinweise (optional)',
    extraNotesPh: 'Alle zusaetzlichen Informationen, die der Fahrer wissen sollte...',
    confirmSubmitTitle: 'Bestaetigen und Ladung erstellen',
    newLoadStep4Sub: 'Schritt 4: Endpruefung der Ladungsdaten',
    fromToLbl: 'Von -> Nach',
    dateTimeLbl: 'Datum und Uhrzeit',
    receiverLbl: 'Empfaenger',
    packagingLbl: 'Verpackung',
    palletsWord: 'Paletten x',
    loosePrefix: 'Ohne Palette:',
    fleetLbl: 'Fahrzeug',
    insuranceLbl: 'Versicherung',
    fullInsurance: 'Vollversicherung',
    euloadInsuranceParens: 'EU.LOAD-Versicherung',
    uniqueRefNote: 'Dieser Ladung wird eine eindeutige Referenznummer zugewiesen',
    submitPublishBtn: 'Ladung erstellen und veroeffentlichen',
    testTracking: 'Test-Tracking',
    trackingBtn: 'Tracking',
    joinTitle: 'EU.LOAD beitreten',
    joinSub: 'Waehlen Sie Ihren Kontotyp, um fortzufahren.',
    priceDriverSub: 'Kostenlos',
    priceCarrierSub: 'Kostenlos',
    priceShipperSub: 'Kostenlos',
    registerNewMember: 'Registrieren - Neues Mitglied',
    alreadyMember: 'Bereits Mitglied?',
    signInSub: 'Fahrer: Telefonnummer + Passwort\nUnternehmen: E-Mail + Passwort',
    loginPhonePh: 'Telefonnummer oder E-Mail',
    passwordPh: 'Passwort',
    driverDetailsTitle: 'Ihre Angaben',
    driverDetailsSub: 'Geben Sie Ihren Namen und Ihre Mobilnummer ein.',
    fullNamePh: 'Vollstaendiger Name',
    phoneExamplePh: '+49 170 000 0000',
    sendSmsCodeBtn: 'SMS-Code senden',
    verifyPhoneTitle: 'Telefon bestaetigen',
    smsCodeSentTo: 'SMS-Code gesendet an',
    didNotReceive: 'Nicht erhalten?',
    resendBtn: 'Erneut senden',
    verifyBtn: 'Bestaetigen',
    createPasswordTitle: 'Passwort erstellen',
    createPasswordSub: 'Sie verwenden dieses Passwort, um sich das naechste Mal anzumelden.',
    createPasswordPh: 'Passwort erstellen',
    yourVehicleTitle: 'Ihr Fahrzeug',
    yourVehicleSub: 'Waehlen Sie den Fahrzeugtyp fuer die Ladungszuordnung.',
    vehicleDetailsLbl: 'Fahrzeugdetails',
    licensePlatePh: 'Kennzeichen (z.B. B-AB 1234)',
    maxCapacityPh: 'Max. Ladekapazitaet (kg)',
    adrRequired: 'ADR erforderlich',
    adrCertWarning: 'Dieses Fahrzeug erfordert ein gueltiges ADR-Zertifikat.',
    completeRegBackToLoads: 'Registrierung abschliessen - Zurueck zu Ladungen',
    companyEmailTitle: 'Firmen-E-Mail',
    companyEmailSub: 'Geben Sie Ihre Firmen-E-Mail ein. Wir senden einen Bestaetigungscode.',
    companyEmailPh: 'firma@beispiel.com',
    sendVerificationCodeBtn: 'Bestaetigungscode senden',
    verifyEmailTitle: 'E-Mail bestaetigen',
    codeSentTo: 'Code gesendet an',
    verifyContinueBtn: 'Bestaetigen und fortfahren',
    companyPasswordSub: 'Sie verwenden dies, um sich das naechste Mal anzumelden.',
    confirmPasswordPh: 'Passwort bestaetigen',
    companyDetailsTitle: 'Firmendetails',
    companyDetailsSub: 'Offizielle Informationen zur Verifizierung.',
    companyLegalNamePh: 'Offizieller Firmenname',
    companyRegNumberPh: 'Handelsregisternummer',
    vatNumberPh: 'USt-IdNr. (z.B. DE123456789)',
    mainActivityPh: 'Haupttaetigkeit',
    fleetTypesLbl: 'Fuhrparktypen',
    cargoTypesShipLbl: 'Warenarten, die Sie versenden',
    adrSpecialLbl: 'ADR / Speziell',
    adrMaterialsWarning: 'Ihre Auswahl umfasst ADR-Materialien. Zusaetzliche Zertifizierung erforderlich.',
    insuranceCheckTitle: 'Frachtversicherung pruefen',
    insuranceCheckSub: 'Gueltige Versicherung ist vor der Verladung erforderlich. Ohne Versicherung ist keine Fortsetzung moeglich.',
    shipperDeclaredInsured: 'Absender hat angegeben, dass die Ladung versichert ist',
    enterPolicyDetailsNote: 'Bitte geben Sie die Policendaten ein. Unvollstaendige oder falsche Angaben werden nicht akzeptiert.',
    policyNumberLbl: 'Policennummer',
    policyNumberPh: 'z.B. POL-2025-123456',
    insuranceCompanyLbl: 'Name der Versicherungsgesellschaft',
    insuranceCompanyPh: 'z.B. Allianz SE',
    policyExpiryLbl: 'Ablaufdatum der Police',
    confirmInsuranceContinue: 'Versicherung bestaetigen und fortfahren',
    policyExpiredWarning: 'Das Ablaufdatum der Police liegt in der Vergangenheit. Die Versicherung ist nicht gueltig.',
    noInsuranceTitle: 'Diese Ladung ist nicht versichert',
    noInsuranceSub: 'Um fortzufahren, muessen Sie die Ladung ueber EU.LOAD versichern.',
    euloadInsuranceLbl: 'EU.LOAD-Versicherung',
    euloadInsuranceDesc: '1% des Warenwerts - volle Deckung',
    euloadInsuranceFeatures: 'Schadensdeckung von Abhol- bis Zielort\nEU.LOAD erhaelt eine Provision aus der Versicherung\nSofortige Zahlung im Schadensfall',
    payEuloadInsuranceBtn: 'Zahlen',
    euloadInsuranceEurSuffix: 'EUR - EU.LOAD-Versicherung',
    euloadInsurancePaidConfirm: 'EU.LOAD-Versicherung bezahlt und aktiviert',
    cargoPhotosTitle: 'Fotos der Ladung',
    cargoPhotosSub: 'Laden Sie mindestens 2 Fotos aus verschiedenen Winkeln der Ladung hoch. Diese Fotos sind rechtliche Transportdokumente.',
    photoLbl: 'Foto',
    uploadingLbl: 'Wird hochgeladen...',
    photoHintText: 'Vorne, hinten, Seiten und oben auf der Ladung\nKlare Qualitaet - Warendetails muessen erkennbar sein',
    photosNeededMorePrefix: 'Noch',
    photosNeededMoreSuffix: 'weitere Foto(s) erforderlich',
    continueToSenderSig: 'Weiter - Unterschrift des Uebergebers',
    senderSigTitle: 'Unterschrift des Uebergebers',
    senderSigSub: 'Der Vertreter des Werks oder Lagers am Abholort muss bestaetigen, dass die Ladung unversehrt uebergeben wurde.',
    senderNameLbl: 'Name des Uebergebers',
    senderNamePh: 'Vor- und Nachname',
    senderSigLabel: 'Unterschrift des Uebergebers',
    senderSigConfirmPrefix: 'Ich,',
    senderSigConfirmSuffix: 'bestaetige, dass ich die Ladung unversehrt uebergeben habe',
    continueToDriverSig: 'Weiter - Unterschrift des Fahrers',
    driverSigTitle: 'Unterschrift des Fahrers',
    driverSigSub: 'Der Fahrer bestaetigt, dass er die Ladung unversehrt uebernommen hat und die Transportverantwortung uebernimmt.',
    responsibilityTransferNote: 'Mit der Unterschrift dieses Dokuments geht die volle Verantwortung fuer die Ladung auf den Fahrer ueber.',
    loadNumberLbl: 'Ladungsnummer',
    driverSigLabel: 'Unterschrift des Fahrers',
    driverSigConfirmText: 'Ich bestaetige, dass ich die Ladung unversehrt uebernommen habe und die Transportverantwortung uebernehme',
    finalConfirmBtn: 'Endgueltig bestaetigen',
    driverWord: 'Fahrer',
    readyToMoveTitle: 'Bereit zur Abfahrt',
    readyToMoveSub: 'Alle Schritte abgeschlossen. Die Ladung wurde offiziell uebernommen und die Abfahrt ist zulaessig.',
    routeLbl: 'Route',
    insuranceSummaryLbl: 'Versicherung',
    photosSummaryLbl: 'Fotos',
    photosRegisteredSuffix: 'Foto(s) erfasst',
    senderSigSummaryLbl: 'Unterschrift Uebergeber',
    driverSigSummaryLbl: 'Unterschrift Fahrer',
    confirmedWord: 'Bestaetigt',
    startTripBtn: 'Fahrt beginnen',
    deliveryAtDestTitle: 'Lieferung am Zielort',
    deliveryAtDestSub: 'Geben Sie den Zustand der Ladung bei der Lieferung an.',
    cargoStatusLbl: 'Zustand der Ladung',
    deliveredIntactBtn: 'Unversehrt geliefert',
    damageOccurredBtn: 'Schaden aufgetreten',
    damageDescLbl: 'Schadensbeschreibung',
    damageDescPh: 'Beschreiben Sie den Schaden...',
    uploadDamagePhotosNote: 'Bitte laden Sie auch Fotos des Schadens hoch',
    continueToWarehouseSig: 'Weiter - Unterschrift des Lagerpersonals',
    laterBtn: 'Spaeter',
    warehouseSigTitle: 'Unterschrift des Lagerpersonals',
    warehouseSigSub: 'Das Lagerpersonal oder der Verantwortliche am Zielort muss bestaetigen.',
    receiverSpecifiedPrefix: 'Angegebener Empfaenger:',
    warehousePersonNameLbl: 'Name des Lagerpersonals / Verantwortlichen',
    receiverSigLabel: 'Unterschrift des Empfaengers',
    receiverSigConfirmPrefix: 'Ich,',
    receiverSigConfirmMiddle: 'bestaetige, dass ich die Ladung',
    intactWord: 'unversehrt',
    withDamageWord: 'mit Schaden',
    receiverSigConfirmSuffix: 'erhalten habe',
    deliverySuccessTitle: 'Erfolgreiche Lieferung',
    deliveryWithDamageTitle: 'Lieferung mit Schaden',
    deliverySuccessSub: 'Die Ladung wurde unversehrt geliefert. Der Vorgang ist abgeschlossen.',
    deliveryDamageSub: 'Der Schadensbericht wurde erfasst. Das EU.LOAD-Team wird pruefen und handeln.',
    statusWord: 'Status',
    deliveredIntactStatus: 'Unversehrt geliefert',
    withDamageStatus: 'Mit Schaden',
    warehouseSigSummaryLbl: 'Unterschrift Lagerpersonal',
    timeWord: 'Zeit',
    closeFileBtn: 'Vorgang abschliessen - Zurueck',
    deliveryPhotosTitle: 'Fotos der Lieferung',
    deliveryPhotosSub: 'Laden Sie mindestens 2 Fotos des Schadens hoch. Diese Fotos sind rechtliche Dokumente.',
    deliveryPhotosOptionalNote: 'Fotos vom Zustand der Ladung bei Lieferung (optional)',
    passwordChangedSuccess: 'Passwort wurde erfolgreich geaendert.',
    capacityWarningPrefix: 'Nicht genuegend Kapazitaet.',
    capacityWarningVehicle: 'Fahrzeugkapazitaet:',
    capacityWarningCurrent: 'Ihre aktuellen Ladungen:',
    capacityWarningThis: 'Diese Ladung:',
    capacityWarningExceed: 'Die Summe uebersteigt die Kapazitaet.',
    offRouteWarning: 'Diese Ladung liegt nicht auf Ihrer Route.\nDas Ziel dieser Ladung ist weit von Ihrer aktuellen Route entfernt.\nFuer Transport ausserhalb der Route wenden Sie sich bitte an den Support.',
    requestSubmittedAlert: 'Ihre Anfrage wurde gesendet. Warten Sie auf die Bestaetigung des Absenders.',
    driverConfirmedAlert: 'Fahrer wurde bestaetigt. Er kann die Ladung nun uebernehmen.',
    requestRejectedAlert: 'Anfrage abgelehnt. Die Ladung ist wieder verfuegbar.',
    confirmCancelRequest: 'Sind Sie sicher, dass Sie diese Anfrage stornieren moechten?',
    confirmDeleteLoad: 'Sind Sie sicher, dass Sie diese Ladung loeschen moechten?',
    pickupDatePastWarning: 'Das Abholdatum darf nicht in der Vergangenheit liegen.',
    noConfirmedLoadWarning: 'Sie haben derzeit keine bestaetigte Ladung zur Lieferung.',
    signOutConfirm: 'Abmelden?',
    loginErrorPrefix: 'Fehler bei der Anmeldung: ',
    busyWarningModalTitle: 'Ladung wird transportiert',
    busyWarningModalSub: 'Sie haben derzeit eine Ladung und sind nicht berechtigt, eine weitere anzunehmen.\nAendern Sie nach der Lieferung Ihren Status auf "Frei".',
    deliveredNowFreeBtn: 'Geliefert - jetzt frei',
    closeBtn: 'Schliessen',
    welcomeBackTitle: 'Willkommen zurueck',
    signInToAccessLoads: 'Melden Sie sich an, um auf Ihre Ladungen zuzugreifen',
    signatureRecorded: 'Unterschrift erfasst',
    deleteWord: 'Loeschen',
    signHereText: 'Hier unterschreiben',
    realTrackingTitle: 'Live-Standort des Fahrers',
    waitingForGpsSignal: 'Warte auf GPS-Signal vom Fahrer...',
    noLocationYet: 'Der Fahrer hat noch keinen Standort gesendet. Dies kann passieren, wenn der Fahrer die Fahrt noch nicht begonnen hat.',
    lastUpdatePrefix: 'Letzte Aktualisierung:',
    openInGoogleMaps: 'In Google Maps oeffnen',
    coordinatesLbl: 'Koordinaten',
  },
  en: {
    register: 'Register',
    signIn: 'Sign In',
    logout: 'Logout',
    profile: 'Profile',
    myLoads: 'My Loads',
    newLoad: '+ New Load',
    available: 'Available',
    onTrip: 'On Trip',
    imAvailable: 'I am available',
    deliverLoad: 'Deliver load',
    tagline: 'Backhaul Platform - Europe',
    liveNetwork: 'Network',
    trucksActive: 'trucks active',
    members: 'Members',
    avgLoad: 'Avg load',
    countries: 'Countries',
    verified: 'Verified',
    insured: 'Insured',
    insurable: 'Insurable',
    myLoad: 'My load',
    departure: 'Departure',
    estArrival: 'Est. Arrival',
    reserved: 'Reserved',
    close: 'Close',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    imFree: 'Available',
    myLoadsTitle: 'My Loads',
    profileTitle: 'Profile',
    newLoadBtn: '+ New Load',
    toCity: 'to',
    weInsure: 'We will insure this',
    shipper: 'Shipper',
    distance: 'Distance',
    weight: 'Weight',
    payment: 'Payment',
    netDays: '30 days net',
    driverAcceptedTitle: 'Driver has accepted this load - verify details:',
    driverNameLbl: 'Driver name',
    plateLbl: 'Plate number',
    vehicleTypeLbl: 'Vehicle type',
    contactLbl: 'Contact',
    matchWarning: 'When handing over the load, always match the plate and identity of the driver. If handed to a different vehicle, responsibility lies with you.',
    driverRequestedTitle: 'A driver has requested this load:',
    nameLbl: 'Name',
    driverConfirmed: 'Driver confirmed',
    yourLoadWaiting: 'This load was created by you and is waiting for a driver.',
    confirmDriver: 'Confirm driver',
    rejectRequest: 'Reject request',
    deleteLoadBtn: 'Delete this load',
    shipperNoAccept: 'To view load details. As a shipper you cannot accept loads.',
    overCapacityWarning: 'The weight of this load is higher than your vehicle capacity. You cannot accept this load.',
    assignedToYou: 'This load has been assigned to you and is now available for you.',
    goToMyLoads: 'To deliver, go to My Loads.',
    assignedOther: 'This load has been assigned to another driver.',
    pendingYours: 'You have requested this load. Waiting for shipper confirmation.',
    pendingOther: 'This load has been reserved by another driver and is awaiting confirmation.',
    requestThisLoad: 'Request this load',
    changeStatus: 'Change My Status',
    myLoadsModalTitle: 'My Loads',
    shipperLoadsSubtitle: 'History of your loads (last 2 years)',
    noLoadsShipper: 'You have not created any loads yet.',
    statusWaitingDriver: 'Waiting for driver',
    statusPendingDriver: 'Driver request',
    statusInTransit: 'In transit',
    statusDelivered: 'Delivered',
    weightLbl: 'Weight',
    priceLbl: 'Price',
    driverLbl: 'Driver',
    approveBtn: 'Approve',
    rejectBtn: 'Reject',
    myActiveLoadsSubtitle: 'Your active loads in delivery order',
    noActiveLoads: 'You have no active loads at the moment.',
    generalCargo: 'General cargo',
    statusConfirmed: 'Confirmed',
    statusWaitingApproval: 'Awaiting approval',
    deliverThisLoad: 'Deliver this load',
    cancelThisRequest: 'Cancel this request',
    deliveryHistory: 'Delivery history',
    delivered: 'Delivered',
    profileModalTitle: 'User Profile',
    profileSubtitle: 'Your account information',
    roleLbl: 'Role',
    roleShipper: 'Shipper',
    roleCarrier: 'Carrier Company',
    roleDriver: 'Independent Driver',
    nameLblProfile: 'Name',
    emailPhoneLbl: 'Email / Phone',
    capacityLbl: 'Capacity',
    companyInfoNote: 'To change company information (CEO, legal representative, registration number, or contact details), please contact support. These changes require re-verification of documents.',
    changePasswordTitle: 'Change Password',
    newPasswordPh: 'New password',
    repeatPasswordPh: 'Repeat new password',
    passwordsMismatch: 'Passwords do not match',
    savePassword: 'Save new password',
    continuePayment: 'Continue - Payment',
    continueDocs: 'Continue - Upload Documents',
    underReview: 'Under Review',
    membershipFeeTitle: 'Membership Fee',
    membershipFeeSub: 'Monthly access to EU.LOAD backhaul network across 18 countries.',
    totalLbl: 'Total',
    perMonth: 'EUR/month',
    roleIndDriver: 'Independent Driver',
    roleCarrierCo: 'Carrier Company',
    roleShipperCo: 'Shipper Company',
    featuresText: 'Full EU-wide load network access\nVerified carrier badge on profile\nCargo insurance support included',
    cardNumberPh: 'Card number',
    mmYYPh: 'MM / YY',
    cvvPh: 'CVV',
    payBtn: 'Pay',
    backToLoads: 'Back to Loads',
    uploadDocsTitle: 'Upload Documents',
    uploadDocsSub: 'Tap each to mark as uploaded. Shippers only see your verified badge.',
    paymentConfirmed: 'Payment confirmed',
    uploadVerificationDocs: 'Upload your verification documents',
    uploadMore: 'Upload More',
    submitBackToLoads: 'Submit and Back to Loads',
    verificationInProgressTitle: 'Verification in Progress',
    verificationSub1: 'Your documents are under review. This takes up to',
    verificationSub2: '24 hours',
    verificationSub3: 'You will be notified via',
    verificationSub4: 'when approved.',
    smsWord: 'SMS',
    emailWord: 'email',
    reviewStep1: 'Compliance team reviews your documents',
    reviewStep2: 'You get notified when approved',
    reviewStep3: 'You can immediately start accepting loads',
    demoSimulate: 'Demo: Simulate Approval',
    gotIt: 'Got It',
    tripStatusTitle: 'Trip Status',
    tripStatusSub: 'Update your availability for shippers.',
    availableForLoads: 'Available for Loads',
    currentlyOnTrip: 'Currently On a Trip',
    busyWarningTitle: 'Load in Transit',
    busyWarningSub: 'You currently have a load and cannot accept another.\nAfter delivery, change your status to "Available".',
    deliveredNowFree: 'Delivered - now available',
    locationRequiredTitle: 'Location Required',
    locationRequiredSub: 'EU.LOAD needs your GPS location to show nearby loads.\nPlease enable location access and try again.',
    noLocationSub: 'The app cannot be used without location access',
    enableGpsBtn: 'Enable GPS',
    retryHint: 'After enabling, tap the button above to retry',
    skipForNow: 'Skip for now',
    lastUpdateNow: 'Last update: just now',
    tripProgress: 'Trip Progress',
    driverInfo: 'Driver Information',
    vehicleTypeLbl2: 'Vehicle Type',
    liveTrackingNote: 'This load is being tracked live.\nIf there is an issue, contact the driver or EU.LOAD support.',
    newLoadTitle: 'Create New Load',
    newLoadStep1Sub: 'Step 1: Route and pickup time',
    fromCityLbl: 'From',
    selectFromCity: 'Select pickup city',
    toCityLbl: 'To',
    selectToCity: 'Select destination city',
    receiverNameLbl: 'Receiver name at destination',
    receiverNamePh: 'Name of warehouse manager or responsible person',
    pickupAddressLbl: 'Exact pickup address',
    pickupAddressPh: 'Street, number, ZIP code, city',
    deliveryAddressLbl: 'Exact delivery address',
    deliveryAddressPh: 'Street, number, ZIP code, city',
    pickupAddressNote: 'This address will be shown to the driver after accepting the load.',
    addressCheckingLbl: 'Checking address...',
    addressValidLbl: 'Address found',
    addressInvalidLbl: 'Address not found. Please check.',
    pickupDateLbl: 'Pickup date',
    pickupTimeLbl: 'Pickup time',
    dateNotPast: 'The pickup date cannot be in the past.',
    dateMax7Days: 'The pickup date can be at most 7 days in the future.',
    continueBtn: 'Continue',
    cancelBtn: 'Cancel',
    cargoDetailsTitle: 'Cargo Details',
    newLoadStep2Sub: 'Step 2: Cargo type and packaging',
    cargoTypeLbl: 'Cargo Type',
    selectCargoType: 'Select cargo type',
    adrWarning: 'This cargo type requires an ADR permit or special authorization.',
    packagingTypeLbl: 'Packaging Type',
    onPallet: 'On Pallet',
    looseCargo: 'Loose (No Pallet)',
    palletCountLbl: 'Number of pallets',
    example10: 'e.g. 10',
    palletWeightLbl: 'Weight per pallet (kg)',
    example500: 'e.g. 500',
    lengthCm: 'Length (cm)',
    widthCm: 'Width (cm)',
    heightCm: 'Height (cm)',
    totalWeightLbl: 'Total weight (kg)',
    totalWeightPh: 'Total load weight in kg',
    palletWeightRangeWarning: 'Weight per pallet must be between 100 and 1500 kg.',
    palletCountRangeWarning: 'Number of pallets must be between 1 and 66.',
    backBtn: 'Back',
    shippingInfoTitle: 'Shipping Information',
    newLoadStep3Sub: 'Step 3: Vehicle type, price and insurance',
    vehicleTypeNeeded: 'Required vehicle type',
    suggestedPrice: 'Suggested price (EUR)',
    example2500: 'e.g. 2500',
    cargoValueLbl: 'Cargo value (EUR)',
    cargoValuePh: 'Actual cargo value - for insurance',
    notShownToDriver: 'This amount is not shown to the driver',
    cargoInsuranceLbl: 'Cargo Insurance',
    hasFullInsurance: 'Cargo has full insurance',
    wantEuloadInsurance: 'I want EU.LOAD insurance',
    noInsurance: 'No insurance',
    euloadPremium: 'EU.LOAD premium:',
    percentValueNote: '(0.5% of cargo value)',
    noInsuranceWarning: 'Without insurance, full responsibility for damage or loss of cargo lies with you, and no coverage will be paid.',
    extraNotesLbl: 'Additional notes (optional)',
    extraNotesPh: 'Any additional information the driver should know...',
    confirmSubmitTitle: 'Confirm and Create Load',
    newLoadStep4Sub: 'Step 4: Final review of load details',
    fromToLbl: 'From -> To',
    dateTimeLbl: 'Date and time',
    receiverLbl: 'Receiver',
    packagingLbl: 'Packaging',
    palletsWord: 'pallets x',
    loosePrefix: 'Loose:',
    fleetLbl: 'Fleet',
    insuranceLbl: 'Insurance',
    fullInsurance: 'Full insurance',
    euloadInsuranceParens: 'EU.LOAD insurance',
    uniqueRefNote: 'A unique reference number will be assigned to this load',
    submitPublishBtn: 'Create and publish load',
    testTracking: 'Test Tracking',
    trackingBtn: 'Tracking',
    joinTitle: 'Join EU.LOAD',
    joinSub: 'Select your account type to continue.',
    priceDriverSub: 'Free',
    priceCarrierSub: 'Free',
    priceShipperSub: 'Free',
    registerNewMember: 'Register - New Member',
    alreadyMember: 'already a member?',
    signInSub: 'Drivers: phone number + password\nCompanies: email + password',
    loginPhonePh: 'Phone number or email',
    passwordPh: 'Password',
    driverDetailsTitle: 'Your Details',
    driverDetailsSub: 'Enter your name and mobile number.',
    fullNamePh: 'Full name',
    phoneExamplePh: '+49 170 000 0000',
    sendSmsCodeBtn: 'Send SMS Code',
    verifyPhoneTitle: 'Verify Phone',
    smsCodeSentTo: 'SMS code sent to',
    didNotReceive: 'Did not receive it?',
    resendBtn: 'Resend',
    verifyBtn: 'Verify',
    createPasswordTitle: 'Create Password',
    createPasswordSub: 'You will use this password to sign in next time.',
    createPasswordPh: 'Create a password',
    yourVehicleTitle: 'Your Vehicle',
    yourVehicleSub: 'Select vehicle type for load matching.',
    vehicleDetailsLbl: 'Vehicle Details',
    licensePlatePh: 'License plate (e.g. B-AB 1234)',
    maxCapacityPh: 'Max load capacity (kg)',
    adrRequired: 'ADR Required',
    adrCertWarning: 'This vehicle requires a valid ADR certificate.',
    completeRegBackToLoads: 'Complete Registration - Back to Loads',
    companyEmailTitle: 'Company Email',
    companyEmailSub: 'Enter your company email. We will send a verification code.',
    companyEmailPh: 'company@example.com',
    sendVerificationCodeBtn: 'Send Verification Code',
    verifyEmailTitle: 'Verify Email',
    codeSentTo: 'Code sent to',
    verifyContinueBtn: 'Verify and Continue',
    companyPasswordSub: 'You will use this to sign in next time.',
    confirmPasswordPh: 'Confirm password',
    companyDetailsTitle: 'Company Details',
    companyDetailsSub: 'Official information for verification.',
    companyLegalNamePh: 'Company legal name',
    companyRegNumberPh: 'Company registration number',
    vatNumberPh: 'VAT number (e.g. DE123456789)',
    mainActivityPh: 'Main business activity',
    fleetTypesLbl: 'Fleet Types',
    cargoTypesShipLbl: 'Cargo Types You Ship',
    adrSpecialLbl: 'ADR / Special',
    adrMaterialsWarning: 'Your selection includes ADR materials. Additional certification required.',
    insuranceCheckTitle: 'Cargo Insurance Check',
    insuranceCheckSub: 'Valid insurance is required before loading. Continuation is not possible without insurance.',
    shipperDeclaredInsured: 'Shipper has declared the cargo is insured',
    enterPolicyDetailsNote: 'Please enter the policy details. Incomplete or incorrect information will not be accepted.',
    policyNumberLbl: 'Policy number',
    policyNumberPh: 'e.g. POL-2025-123456',
    insuranceCompanyLbl: 'Insurance company name',
    insuranceCompanyPh: 'e.g. Allianz SE',
    policyExpiryLbl: 'Policy expiry date',
    confirmInsuranceContinue: 'Confirm insurance and continue',
    policyExpiredWarning: 'The policy expiry date is in the past. The insurance is not valid.',
    noInsuranceTitle: 'This cargo is not insured',
    noInsuranceSub: 'To continue you must insure the cargo through EU.LOAD.',
    euloadInsuranceLbl: 'EU.LOAD Insurance',
    euloadInsuranceDesc: '1% of cargo value - full coverage',
    euloadInsuranceFeatures: 'Damage coverage from origin to destination\nEU.LOAD receives a commission from the insurance\nImmediate payment in case of damage',
    payEuloadInsuranceBtn: 'Pay',
    euloadInsuranceEurSuffix: 'EUR - EU.LOAD Insurance',
    euloadInsurancePaidConfirm: 'EU.LOAD insurance paid and activated',
    cargoPhotosTitle: 'Cargo Photos',
    cargoPhotosSub: 'Upload at least 2 photos from different angles of the cargo. These photos are legal transport documents.',
    photoLbl: 'Photo',
    uploadingLbl: 'Uploading...',
    photoHintText: 'Front, back, sides and top of the cargo\nClear quality - cargo details must be visible',
    photosNeededMorePrefix: '',
    photosNeededMoreSuffix: 'more photo(s) required',
    continueToSenderSig: 'Continue - Sender Signature',
    senderSigTitle: 'Sender Signature',
    senderSigSub: 'The representative of the factory or origin warehouse must confirm that the cargo was handed over intact.',
    senderNameLbl: 'Sender name',
    senderNamePh: 'Full name',
    senderSigLabel: 'Sender signature',
    senderSigConfirmPrefix: 'I,',
    senderSigConfirmSuffix: 'confirm that I have handed over the cargo intact',
    continueToDriverSig: 'Continue - Driver Signature',
    driverSigTitle: 'Driver Signature',
    driverSigSub: 'The driver confirms that they have received the cargo intact and accepts responsibility for transport.',
    responsibilityTransferNote: 'By signing this document, full responsibility for the cargo transfers to the driver.',
    loadNumberLbl: 'Load number',
    driverSigLabel: 'Driver signature',
    driverSigConfirmText: 'I confirm that I have received the cargo intact and accept responsibility for transport',
    finalConfirmBtn: 'Final Confirm',
    driverWord: 'Driver',
    readyToMoveTitle: 'Ready to Move',
    readyToMoveSub: 'All steps completed. The cargo has been officially received and departure is authorized.',
    routeLbl: 'Route',
    insuranceSummaryLbl: 'Insurance',
    photosSummaryLbl: 'Photos',
    photosRegisteredSuffix: 'photo(s) registered',
    senderSigSummaryLbl: 'Sender signature',
    driverSigSummaryLbl: 'Driver signature',
    confirmedWord: 'Confirmed',
    startTripBtn: 'Start Trip',
    deliveryAtDestTitle: 'Delivery at Destination',
    deliveryAtDestSub: 'Specify the condition of the cargo upon delivery.',
    cargoStatusLbl: 'Cargo Status',
    deliveredIntactBtn: 'Delivered intact',
    damageOccurredBtn: 'Damage occurred',
    damageDescLbl: 'Damage description',
    damageDescPh: 'Describe the damage...',
    uploadDamagePhotosNote: 'Please also upload photos of the damage',
    continueToWarehouseSig: 'Continue - Warehouse Staff Signature',
    laterBtn: 'Later',
    warehouseSigTitle: 'Warehouse Staff Signature',
    warehouseSigSub: 'The warehouse staff or responsible person at the destination must confirm.',
    receiverSpecifiedPrefix: 'Specified receiver:',
    warehousePersonNameLbl: 'Name of warehouse staff / responsible person',
    receiverSigLabel: 'Receiver signature',
    receiverSigConfirmPrefix: 'I,',
    receiverSigConfirmMiddle: 'confirm that I received the cargo',
    intactWord: 'intact',
    withDamageWord: 'with damage',
    receiverSigConfirmSuffix: '',
    deliverySuccessTitle: 'Successful Delivery',
    deliveryWithDamageTitle: 'Delivery with Damage',
    deliverySuccessSub: 'The cargo was delivered intact. The file is closed.',
    deliveryDamageSub: 'The damage report has been filed. The EU.LOAD team will review and take action.',
    statusWord: 'Status',
    deliveredIntactStatus: 'Delivered intact',
    withDamageStatus: 'With damage',
    warehouseSigSummaryLbl: 'Warehouse staff signature',
    timeWord: 'Time',
    closeFileBtn: 'Close file - Back',
    deliveryPhotosTitle: 'Delivery Photos',
    deliveryPhotosSub: 'Upload at least 2 photos of the damage. These photos are legal documents.',
    deliveryPhotosOptionalNote: 'Photos of cargo condition at delivery (optional)',
    passwordChangedSuccess: 'Password changed successfully.',
    capacityWarningPrefix: 'Not enough capacity.',
    capacityWarningVehicle: 'Vehicle capacity:',
    capacityWarningCurrent: 'Your current loads:',
    capacityWarningThis: 'This load:',
    capacityWarningExceed: 'The total exceeds capacity.',
    offRouteWarning: 'This load is not on your route.\nThe destination of this load is far from your current route.\nFor transport off-route, please contact support.',
    requestSubmittedAlert: 'Your request has been submitted. Waiting for shipper confirmation.',
    driverConfirmedAlert: 'Driver confirmed. They can now pick up the load.',
    requestRejectedAlert: 'Request rejected. The load is available again.',
    confirmCancelRequest: 'Are you sure you want to cancel this request?',
    confirmDeleteLoad: 'Are you sure you want to delete this load?',
    pickupDatePastWarning: 'The pickup date cannot be in the past.',
    noConfirmedLoadWarning: 'You currently have no confirmed load to deliver.',
    signOutConfirm: 'Sign out?',
    loginErrorPrefix: 'Login error: ',
    busyWarningModalTitle: 'Load in Transit',
    busyWarningModalSub: 'You currently have a load and are not allowed to accept another.\nAfter delivery, change your status to "Available".',
    deliveredNowFreeBtn: 'Delivered - now available',
    closeBtn: 'Close',
    welcomeBackTitle: 'Welcome Back',
    signInToAccessLoads: 'Sign in to access your loads',
    signatureRecorded: 'Signature recorded',
    deleteWord: 'Delete',
    signHereText: 'Sign here',
    realTrackingTitle: 'Driver Live Location',
    waitingForGpsSignal: 'Waiting for GPS signal from driver...',
    noLocationYet: 'The driver has not sent a location yet. This can happen if the driver has not started the trip yet.',
    lastUpdatePrefix: 'Last update:',
    openInGoogleMaps: 'Open in Google Maps',
    coordinatesLbl: 'Coordinates',
  },
};

export const t = (lang, key) => {
  return TRANSLATIONS[lang]?.[key] || TRANSLATIONS.de[key] || key;
};
